import { render, staticRenderFns } from "./PerIndGrpHelpList.vue?vue&type=template&id=6644090d&"
import script from "./PerIndGrpHelpList.vue?vue&type=script&lang=js&"
export * from "./PerIndGrpHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports